import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import api from '../../config/axions.config';
import { toast } from 'sonner';
import Swal from 'sweetalert2';
import { showDate } from '../../constant';

const Expenses = () => {
  let navigate = useNavigate();
  const [expenseData, setExpenseData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);

  useEffect(() => {
    getExpenseData();
  }, []);

  async function getExpenseData() {
    try {
      let response = await api.get("expenses");
      if (response.status) {
        setExpenseData(response.data.data?.expensesList);
      } else {
        alert("Something is wrong, data not received");
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function deleteSelected(item) {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to Delete the Expense.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let responce = await api.delete(`expenses/${item?._id}`);
          if (responce.data.status) {
            toast.success(responce.data.message);
          } else {
            toast.error(responce.data.message);
          }
        } catch (error) {
          toast.error(error.response.data.message);
          let list = error.response.data.errors || [];
          for (let item of list) {
            toast.warning(item.msg)
          }
        }
      }
    });
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = expenseData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(expenseData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [payment_type, setPayment_type] = useState('');
  const [payment_typeList, setPayment_typeList] = useState([]);

  async function getPaymentType() {
    try {
      let responce = await api.get("paymentType")
      if (responce?.data.status) {
        setPayment_typeList(responce?.data.data?.PaymentTypes);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    getPaymentType();
  }, [])
  return (
    <div>
      <div className='grow ms-0 md:ms-0 lg:ms-56'>
        <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
          <div className='flex items-center justify-end lg:justify-between'>
            <h1 className="hidden text-2xl font-semibold text-primary-600 lg:block">
              Expenses
            </h1>

            <button type="button" onClick={() => navigate('/dashboard/expense/add-expense')} className="w-full btn sm:w-auto btn-primary leading-icon mb-5 md:mb-5 lg:mb-0" data-toggle="modal" data-target="#addClassModal">
              <svg stroke="currentColor" viewBox="0 0 256 256">
                <line x1="40" y1="128" x2="216" y2="128" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                <line x1="128" y1="40" x2="128" y2="216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
              </svg>
              Add New Expense
            </button>
          </div>

          <div className="space-y-6 lg:mt-6">
            <div className="overflow-hidden bg-white rounded-lg shadow">
              <div className="px-4 py-5 sm:px-6">
                <div className='flex justify-between'>
                  <div className='flex space-x-6'>
                    <div className="max-w-lg">
                      <label htmlFor="searchStudents" className="sr-only">
                        Search
                      </label>
                      <div className="relative rounded-md">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                          <svg className="w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                          </svg>
                        </div>
                        <input type="text" name="searchStudents" id="searchStudents" className="block w-full pr-4 py-2.5 rounded-lg focus:border-primary-600 focus:ring-primary-600 border border-gray-200 shadow-sm !pl-10" placeholder="Search student by name, email, phone or address..." />
                      </div>
                    </div>

                    <div className="">
                      <select onChange={(e) => setPayment_type(e.target.value)} >
                        <option value={null}>
                          {"Payment Type"}
                        </option>
                        {
                          payment_typeList?.map(item => (
                            <option key={item._id} value={item._id}>
                              {item.type}
                            </option>
                          ))
                        }
                      </select>
                    </div>

                    <div className="flex items-center ml-8 space-x-2">
                      <select name="" id="">
                        <option value="">
                          Time
                        </option>
                        <option value="last week">
                          Last Week
                        </option>
                        <option value="last 10 days">
                          Last 10 days
                        </option>
                        <option value="last month">
                          Last Month
                        </option>
                        <option value="">
                          Coustom...
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="flex items-center ml-8 space-x-2">
                    <span>
                      Show
                    </span>
                    <select onChange={(e) => setItemsPerPage(e.target.value)}>
                      <option value="10">
                        10
                      </option>
                      <option value="9">
                        9
                      </option>
                      <option value="8">
                        8
                      </option>
                      <option value="7">
                        7
                      </option>
                      <option value="6">
                        6
                      </option>
                      <option value="5">
                        5
                      </option>
                    </select>
                    <span>
                      records
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex flex-col">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <div className="overflow-hidden">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th scope="col" className="hidden sm:table-cell">
                              Payee's Name
                            </th>
                            <th scope="col" className="hidden lg:table-cell">
                              Payer's Name
                            </th>
                            <th scope="col" className="hidden lg:table-cell">
                              Total Amount
                            </th>
                            <th scope="col" className="hidden lg:table-cell">
                              Payment Type
                            </th>
                            <th scope="col" className="hidden lg:table-cell">
                              Payment Date
                            </th>
                            <th scope="col" className="hidden sm:table-cell">
                              Status
                            </th>
                            <th scope="col" className="hidden lg:table-cell">
                              Action
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {
                            currentItems.map(item => (
                              <tr key={item._id}>
                                <td className="hidden sm:table-cell">
                                  {item.pay_to}
                                </td>
                                <td className="hidden lg:table-cell">
                                  {item.usersData.firstname + " " + item.usersData.lastname}
                                </td>
                                <td className="hidden lg:table-cell">
                                  {item.amount}
                                </td>
                                <td className="hidden lg:table-cell">
                                  {item.paymentIn.type}
                                </td>
                                <td className="hidden lg:table-cell">
                                  {showDate(item.Payment_date)}
                                </td>
                                <td className="hidden sm:table-cell">
                                  {item.is_active ?
                                    (<span className='px-4 py-3 bg-green-500 rounded-md text-white text-center'>Active</span>)
                                    :
                                    (<span className='px-2 py-3 bg-red-500 rounded-md text-white text-center'>Deactive</span>)}
                                </td>
                                <td>
                                  <div className="hidden lg:table-cell">
                                    <div className="dropdown xl:hidden">
                                      <button type="button" className="btn-cricle dropdown-toggle" data-toggle="dropdown" id="dropdownMenuButton" aria-haspopup="true" aria-expanded="true">
                                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 256 256">
                                          <circle cx="128" cy="128" r="16"></circle>
                                          <circle cx="64" cy="128" r="16"></circle>
                                          <circle cx="192" cy="128" r="16"></circle>
                                        </svg>
                                      </button>

                                      <div className="dropdown-menu" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
                                        <div className="divide-y divide-gray-100">
                                          <div className="py-1" role="none">
                                            <div title="View Class Details" className="dropdown-item" role="menuitem" tabIndex="-1">
                                              View
                                            </div>
                                            <div title="Edit Class" className="dropdown-item" role="menuitem" tabIndex="-1">
                                              Edit
                                            </div>
                                            <div title="Delete Class" className="dropdown-item" role="menuitem" tabIndex="-1">
                                              Delete
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div title="View Class Details" className="hidden btn-circle xl:inline-flex" aria-label="View" data-microtip-position="top" data-target="tooltip" role="button" onClick={() => navigate('/dashboard/expense/view-expense', { state: item })}>
                                      <svg className="w-5 h-5" stroke="currentColor" viewBox="0 0 256 256">
                                        <path d="M128,55.99219C48,55.99219,16,128,16,128s32,71.99219,112,71.99219S240,128,240,128,208,55.99219,128,55.99219Z" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></path>
                                        <circle cx="128" cy="128" r="32" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></circle>
                                      </svg>
                                    </div>

                                    <div title="Edit Class" className="hidden btn-circle xl:inline-flex" aria-label="Edit" data-microtip-position="top" data-target="tooltip" role="button" onClick={() => navigate('/dashboard/expense/edit-expense', { state: item })}>
                                      <svg className="w-5 h-5" stroke="currentColor" viewBox="0 0 256 256">
                                        <path d="M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></path>
                                        <line x1="136" y1="64" x2="192" y2="120" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                                        <line x1="44" y1="156" x2="100" y2="212" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                                      </svg>
                                    </div>

                                    <div title="Delete Class" className="hidden btn-circle xl:inline-flex" aria-label="Delete" data-microtip-position="top" data-target="tooltip" role="button">
                                      <svg className="w-5 h-5" stroke="currentColor" viewBox="0 0 256 256">
                                        <rect width="256" height="256" fill="none"></rect>
                                        <line x1="215.99609" y1="60" x2="39.99609" y2="60.00005" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                                        <line x1="104" y1="104" x2="104" y2="168" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                                        <line x1="152" y1="104" x2="152" y2="168" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                                        <path d="M200,60V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V60" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></path>
                                        <path d="M168,60V36a16,16,0,0,0-16-16H104A16,16,0,0,0,88,36V60" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></path>
                                      </svg>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-4 py-5 bg-white border-t border-gray-200 sm:px-6">
                <div className="px-4 bg-white border-gray-200">
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-sm text-gray-700">
                        Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, expenseData.length)} of {expenseData.length} results
                      </p>
                    </div>
                    <div className="flex">
                      <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className={`inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-50 ${currentPage === 1 ? 'text-gray-400' : 'text-black'}`}
                      >
                        <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      </button>

                      {[...Array(totalPages).keys()].map((num) => {
                        const pageNumber = num + 1;

                        const firstPageToShow = Math.max(1, currentPage - 1);
                        const lastPageToShow = Math.min(totalPages, currentPage + 1);

                        if (pageNumber >= firstPageToShow && pageNumber <= lastPageToShow) {
                          return (
                            <button
                              key={pageNumber}
                              onClick={() => handlePageChange(pageNumber)}
                              className={`inline-flex items-center px-4 py-2 text-sm font-medium border text-gray-500 ${currentPage === pageNumber ? 'bg-primary-100 border-primary-600 text-primary-600' : 'text-black'}`}
                            >
                              {pageNumber}
                            </button>
                          );
                        }
                        return null;
                      })}

                      <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className={`inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-50 ${currentPage === totalPages ? 'text-gray-400' : 'text-black'}`}
                      >
                        <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Expenses
